/* tslint:disable */
/* eslint-disable */
/**
 * Hermes Console
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * shiftReports
 * @export
 * @interface ShiftsRequest
 */
export interface ShiftsRequest {
    /**
     * 営業所ID
     * @type {number}
     * @memberof ShiftsRequest
     */
    officeId?: number;
    /**
     * multiple営業所で検索のためのリスト
     * @type {Array<number>}
     * @memberof ShiftsRequest
     */
    officeIds?: Array<number>;
    /**
     * multiple乗務員で検索のためのリスト
     * @type {Array<number>}
     * @memberof ShiftsRequest
     */
    driverIds?: Array<number>;
    /**
     * 乗務日(年月日 yyyymmddで返される)
     * @type {number}
     * @memberof ShiftsRequest
     */
    shiftStartDate?: number;
    /**
     * 年月日
     * @type {number}
     * @memberof ShiftsRequest
     */
    shiftEndDate?: number;
}

export function ShiftsRequestFromJSON(json: any): ShiftsRequest {
    return ShiftsRequestFromJSONTyped(json, false);
}

export function ShiftsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ShiftsRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'officeId': !exists(json, 'office_id') ? undefined : json['office_id'],
        'officeIds': !exists(json, 'office_ids') ? undefined : json['office_ids'],
        'driverIds': !exists(json, 'driver_ids') ? undefined : json['driver_ids'],
        'shiftStartDate': !exists(json, 'shift_start_date') ? undefined : json['shift_start_date'],
        'shiftEndDate': !exists(json, 'shift_end_date') ? undefined : json['shift_end_date'],
    };
}

export function ShiftsRequestToJSON(value?: ShiftsRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'office_id': value.officeId,
        'office_ids': value.officeIds,
        'driver_ids': value.driverIds,
        'shift_start_date': value.shiftStartDate,
        'shift_end_date': value.shiftEndDate,
    };
}


